import React from 'react';

const Footer = () => {
    return (
        <footer className="bg-background-dark pt-32 pb-16 relative overflow-hidden">
            <div className="max-w-[1400px] mx-auto px-8 relative z-10">
                <div className="text-center mb-32">
                    <h2 className="text-7xl md:text-[120px] font-black sports-font text-white mb-12">
                        LET'S WORK <span className="text-primary">TOGETHER</span>
                    </h2>
                    {/*<p className="text-white/50 max-w-xl mx-auto text-lg mb-12 font-light">*/}
                    {/*    Currently accepting select projects for Q3-Q4 2024. Reach out to discuss how we can build your next high-performance platform.*/}
                    {/*</p>*/}
                    <a className="inline-flex items-center gap-6 text-white hover:text-primary transition-all group" href="mailto:career@tavenharris.com">
                        <span className="text-2xl font-black sports-font tracking-widest">career@tavenharris.com</span>
                        <span className="material-symbols-outlined text-4xl group-hover:translate-x-4 transition-transform">arrow_forward</span>
                    </a>
                </div>
                <div className="pt-16 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-12">
                    <div className="flex items-center gap-4">
                        <div className="size-8 bg-white/10 flex items-center justify-center">
                            <span className="text-white font-black italic text-sm">TH</span>
                        </div>
                        <span className="font-black sports-font text-xl">Taven<span className="text-primary">.</span>HARRIS</span>
                    </div>
                    <div className="flex gap-12">
                        <a className="text-[10px] font-bold uppercase tracking-[0.3em] text-white/40 hover:text-primary transition-colors" href="https://github.com/tavenharris" target="_blank" rel="noopener noreferrer">GitHub</a>
                        <a className="text-[10px] font-bold uppercase tracking-[0.3em] text-white/40 hover:text-primary transition-colors" href="https://www.linkedin.com/in/tavenharris/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
                    </div>
                    <p className="text-[10px] font-mono text-white/20">©2026 TAVEN_HARRIS. ALL_RIGHTS_RESERVED.</p>
                </div>
            </div>
            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full h-[300px] bg-gradient-to-t from-primary/5 to-transparent pointer-events-none"></div>
        </footer>
    );
};

export default Footer;
